import http from 'hub-http/clients/apiClient';
// @ts-expect-error no types
import { catchAndRethrowNetworkError } from 'crm_data/quotes/monitoring/errorUtils';
const DOMAINS_ENDPOINT = 'invoices/v1/invoices-template/domains';
export function getDomains() {
  return http.get(DOMAINS_ENDPOINT).then(domains => domains).catch(catchAndRethrowNetworkError);
}